import { mdiHomeOutline, mdiTruckOutline, mdiPackageVariantClosed } from '@mdi/js'
import { PRIVATE } from '@/plugins/acl/const'

export default [
  {
    subheader: 'logistics',
    resource: PRIVATE.LOGISTICS.MENU_HEADER,
    action: 'read',
  },
  {
    title: 'apartments',
    icon: mdiHomeOutline,
    to: 'logistics-apartments-list',
    resource: PRIVATE.STAFF.HOUSES,
    action: 'read',
  },
  {
    title: 'fleet',
    icon: mdiTruckOutline,
    to: 'logistics-fleet',
    resource: PRIVATE.LOGISTICS.FLEET,
    action: 'read',
  },
  {
    title: 'resources',
    icon: mdiPackageVariantClosed,
    to: 'logistics-resources',
    resource: PRIVATE.LOGISTICS.RESOURCES,
    action: 'read',
  },
]
